import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import DirectorRegistered from "./DirectorRegistered";
import { format } from "date-fns";

const ConfirmAppointment = ({ isCongrats, onEdit, formUpdate }) => {
  const regData = useSelector((state) => state.directorsRegForm.regData || {});
  const appointmentData = Array.isArray(regData) ? regData : [regData];

  const flattenDirectorsData = (directors = []) => {
    if (!Array.isArray(directors)) return [];
    return directors.reduce((acc, director) => {
      const formatDate = (date) => {
        return date ? format(date, "MMMM do, yyyy") : "-";
      };
      const directorLevelData = {
        id: director.id,
        name:
          director.preferred_name ||
          [director.name, director.other_name, director.last_name]
            .filter(Boolean)
            .join(" "),
        position: director.position,
        start_date: formatDate(director.start_date),
        end_date: formatDate(director.end_date),
        status: director.status,
      };

      const positionsArray = (director.positions || []).map((position) => ({
        id: director.id,
        name: directorLevelData.name,
        position: position.position,
        start_date: formatDate(position.start_date),
        end_date: formatDate(position.end_date),
        status: position.status,
      }));

      return acc.concat(directorLevelData, positionsArray);
    }, []);
  };

  const flattenAppointmentData = flattenDirectorsData(appointmentData);

  const actionBodyTemplate = (rowData) => {
    const selectedDirectorUpdate = appointmentData.filter(
      (director) => director.id === rowData.id,
    );

    return (
      <div className="flex align-items-center">
        <span
          className="pi pi-pencil ml-4 mr-3 pencil-pointer"
          onClick={() => onEdit(selectedDirectorUpdate)}
        ></span>
      </div>
    );
  };

  const statusTemplate = (rowData) => {
    const renderStatus = (status) => {
      switch (status) {
        case "Active":
          return (
            <>
              <span className="pi pi-circle-fill active-circle-fill"></span>{" "}
              Active
            </>
          );
        case "Not Active":
          return (
            <>
              <span className="pi pi-circle-fill not-active-circle-fill"></span>{" "}
              Not Active
            </>
          );
        case "Removed":
          return (
            <>
              <span className="pi pi-circle-fill removed-circle-fill"></span>{" "}
              Removed
            </>
          );
        default:
          return "";
      }
    };

    return (
      <>
        <div>{renderStatus(rowData.status)}</div>
        <div>
          {rowData.secondaryStatus ? renderStatus(rowData.secondaryStatus) : ""}
        </div>
      </>
    );
  };

  return (
    <>
      {!isCongrats ? (
        <>
          <div className="formgrid grid">
            <div className="field col-12">
              {formUpdate ? (
                <p className="add-new-entity-heading mb-2">Confirm Updates</p>
              ) : (
                <p className="add-new-entity-heading mb-2">
                  Confirm Appointment
                </p>
              )}
              <p className="input-label m-0">
                Please confirm the data you entered before confirming the
                appointment.
              </p>
            </div>
            <div className="field col-12 mb-0">
              <p className="current-position-head">Appointment Summary</p>
            </div>
            <div className="field col-12 mt-2">
              <div className="card">
                <DataTable
                  value={flattenAppointmentData}
                  rowGroupMode="rowspan"
                  groupRowsBy="name"
                  sortMode="multiple"
                  tableStyle={{ minWidth: "50rem" }}
                  paginator={flattenAppointmentData?.length > 10}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  rows={10}
                  rowsPerPageOptions={[10, 20, 30]}
                  className="datatable-right-align"
                  emptyMessage="No results were found"
                >
                  <Column
                    field="name"
                    header="Full Name"
                    className="table-col-width"
                    sortable
                    rowspan
                  ></Column>
                  <Column
                    field="position"
                    header="Position"
                    className="table-col-width"
                    body={(rowData) => <div>{rowData.position || ""}</div>}
                  ></Column>
                  <Column
                    field="start_date"
                    header="Appointment Date"
                    className="table-col-width"
                    body={(rowData) => <div>{rowData.start_date || "-"}</div>}
                  ></Column>
                  <Column
                    field="end_date"
                    header="End Date"
                    className="table-col-width"
                    body={(rowData) => <div>{rowData.end_date || "-"}</div>}
                  ></Column>
                  <Column
                    field="status"
                    header="Status"
                    className="table-col-width"
                    body={(rowData) => statusTemplate(rowData)}
                  ></Column>
                  <Column
                    body={actionBodyTemplate}
                    className="table-col-width"
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </>
      ) : (
        <DirectorRegistered />
      )}
    </>
  );
};

export default ConfirmAppointment;
